export default [
	{
		featureType: 'administrative.neighborhood',
		elementType: 'labels.text',
		stylers: [{ "visibility": "off" }]
	},
];
